import {createSlice} from '@reduxjs/toolkit';

export interface ChangesState {
    unsavedChanges: boolean,
    confirm: boolean,
    discard: boolean,
    cancel: boolean,
}

const initialState: ChangesState = {
    unsavedChanges: false,
    confirm: false,
    discard: false,
    cancel: false,
}

export const changesSlice = createSlice({
    name: 'changes',
    initialState,
    reducers: {
        setUnsavedChanges(state, action){
            state.unsavedChanges = action.payload;
        },
        setConfirm(state, action){
            state.confirm = action.payload;
        },
        setDiscard(state, action){
            state.discard = action.payload;
        },
        setCancel(state, action){
            state.cancel = action.payload;
        },
    },
})

// Action creators are generated for each case reducer function
export const { setUnsavedChanges, setConfirm, setDiscard, setCancel } = changesSlice.actions

export default changesSlice.reducer